var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hy-card"},[_c('div',{staticClass:"hy-card-head"},[_vm._t("head")],2),_c('div',{staticClass:"hy-card-content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }